import { ElementResultInfo } from "projects/phdsoft/common/src/lib/models/element-result-info.model";
import { ChecklistItem } from "src/app/collections/collection-inspection/_models/checklist.model";
import { WorkableElement } from "../WorkableElement";
import { GaugingElement } from "./gaugingElement";
import type { Mesh, Material, Vector3 } from '@phdsoft/three';

export class GaugingPoint extends GaugingElement {


    // scope: InspectionScope;
    point: Vector3;

    public get gaugingValue(): number {
        return this._gaugingValue;
    }
    public set gaugingValue(v: number) {
        this._gaugingValue = v;
    }

    public get _type(): string {
        return 'POINT';
    }

    constructor(mesh: Mesh, material: Material, targetElement: WorkableElement, checkList: Array<ChecklistItem>, _elementResult: ElementResultInfo) {
        super(mesh, material, [targetElement], checkList, _elementResult);
        this.SurfaceDesign.userData.scale = 2;
        this.elementTypeName = 'GaugingPoint';
        // this._gaugingValue = Number(checkList[0]?.Value);
    }

    public updateMaterial(data: Date): void {

    }

}
